import React from "react";
import Translate from "react-translate-component";
import FormattedAsset from "../../Utility/FormattedAsset";
export const BondAcceptOffer = ({
  op,
  linkToAccount,
  current
}) => {
  if (current === op[1].lender) {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "proposal.bond_accept_offer"
    }), "\xA0", /*#__PURE__*/React.createElement(FormattedAsset, {
      style: {
        fontWeight: "bold"
      },
      amount: op[1].amount_borrowed.amount,
      asset: op[1].amount_borrowed.asset_id
    }), /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "proposal.to"
    }), "\xA0", linkToAccount(op[1].borrower));
  } else if (current === op[1].borrower) {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "proposal.bond_accept_offer"
    }), "\xA0", /*#__PURE__*/React.createElement(FormattedAsset, {
      style: {
        fontWeight: "bold"
      },
      amount: op[1].amount_borrowed.amount,
      asset: op[1].amount_borrowed.asset_id
    }), /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "proposal.from"
    }), "\xA0", linkToAccount(op[1].lender));
  } else {
    return null;
  }
};